import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL;
const anon = import.meta.env.VITE_SUPABASE_ANON_KEY;

export const hasSupabasePublicConfig = Boolean(url && anon);

if (!hasSupabasePublicConfig) {
  console.warn(
    '[lunins-storefront] Defina VITE_SUPABASE_URL e VITE_SUPABASE_ANON_KEY no .env (somente chave anon).'
  );
}

/**
 * Cliente público: apenas anon — sem service role no browser.
 * Sem .env, usamos um endereço reservado só para o site não quebrar na tela
 * (a loja estática continua visível; chamadas ao banco ficam desligadas).
 */
export const supabase = createClient(
  url || 'https://example.supabase.co',
  anon || 'public-anon-placeholder'
);
